var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:("boolean " + (_vm.value === true ? 'is-true' : '') + " " + (_vm.value === false ? 'is-false' : ''))})}
var staticRenderFns = []

export { render, staticRenderFns }